import { useEffect, useContext, useReducer } from "react";
import AuthContext from "../../components/context/AuthContext";
import { useNavigate } from "react-router-dom";
import useCrews from "./useCrews";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import DevModeLabel from "../../components/ui/labels/DevModeLabel";
import Dropdown from "../../components/ui/dropdowns/Dropdown";
import Form from "../../components/ui/input/Form";
import FullScreenActivityIndicator from "../../components/ui/activityIndicator/FullScreenActivityIndicator";
import InfoPrompt from "../../components/ui/prompts/InfoPrompt";
import CrewForm from "./CrewForm";
import { initialState, reducer } from "./crewsReducer";
import useGroupMemberships from "../../hooks/useGroupMemberships";

const Crews = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);
  const groupMemberships = useGroupMemberships();

  const {
    convertCrewHandler,
    crewSelectHandler,
    clearStatus,
    contractorSelectHandler,
    convertContractorsHandler,
  } = useCrews({
    state,
    dispatch,
  });

  // Guard against someone accessing the page without being an admin or audit admin.
  useEffect(() => {
    let isAdmin = groupMemberships.isPrimary || groupMemberships.isAuditPrimary;
    if (!isAdmin)
      navigate("/home", {
        replace: true,
      });
  }, [groupMemberships, authCtx, navigate]);

  return (
    <>
      <SectionHeader text={"Create/Edit Crew"} />
      <DevModeLabel />
      <Form>
        <Dropdown
          identifier="auditCrew"
          title="Crew"
          url={`${process.env.REACT_APP_API_URL}/data/crews`}
          fetchingMessage="Fetching Crews..."
          noOptionsMessage="No crews found."
          value={state.selectedCrew}
          selectHandler={crewSelectHandler}
          convertOptionsHandler={convertCrewHandler}
          dependencies={[state.fetchCrews]}
        />

        {state?.selectedCrew?.value && (
          <>
            <SectionHeader
              text={state?.selectedCrew?.value?.id === 0 ? "Create" : "Edit"}
            />
            <Dropdown
              identifier="contractor"
              title="Contractor"
              url={`${process.env.REACT_APP_API_URL}/data/contractors`}
              fetchingMessage="Fetching Contractors..."
              noOptionsMessage="No contractors found."
              value={state.selectedContractor}
              selectHandler={contractorSelectHandler}
              convertOptionsHandler={convertContractorsHandler}
              required={true}
            />
          </>
        )}
        {state?.selectedCrew?.value && state?.selectedCrew?.value?.id === 0 && (
          <CrewForm mode="Create" state={state} dispatch={dispatch} />
        )}
        {state?.selectedCrew?.value && state?.selectedCrew?.value?.id !== 0 && (
          <CrewForm mode="Edit" state={state} dispatch={dispatch} />
        )}
      </Form>

      <FullScreenActivityIndicator
        loading={state.loading}
        text="Submitting Form..."
      />
      <InfoPrompt text={state.status} statusCleared={clearStatus} />
    </>
  );
};

export default Crews;
